import React from 'react'
import Typography from '@material-ui/core/Typography'
import { TogglePill, getPillBackground } from './TogglePill'

/**
 * A compact pill toggle — no ON/OFF text, regular-weight label.
 *
 * Props:
 *   isOn        {boolean}
 *   label       {string}
 *   onClick     {function} - makes it interactive
 *   disabled    {boolean}  - grey non-interactive appearance
 *   activeColor {string}   - color when ON (default: '#1976d2')
 *   style       {object}   - applied to the container
 */
export default function SmallPillToggle({ isOn, label, onClick, disabled = false, activeColor = '#1976d2', style }) {
  const interactive = !disabled && !!onClick
  const pillBackground = getPillBackground(isOn, disabled, activeColor)
  const textColor = interactive ? (isOn ? activeColor : '#000') : undefined

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        cursor: interactive ? 'pointer' : undefined,
        ...style,
      }}
      onClick={interactive ? onClick : undefined}
    >
      <TogglePill
        isOn={isOn}
        background={pillBackground}
        width={44}
        height={20}
        borderRadius={10}
        thumbSize={14}
        thumbOnLeft={27}
        showOnOff={false}
      />
      <Typography style={{ fontSize: '13px', fontWeight: 400, color: textColor, userSelect: 'none' }}>
        {label}
      </Typography>
    </div>
  )
}
